// @spec VUL-STR-003
import { createFileRoute } from '@tanstack/react-router';

import { VulnerabilityCreatePage } from '@/features/vulnerabilities/pages/VulnerabilityCreatePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/new')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.createVulnerability'),
  }),
  component: VulnerabilityCreatePage,
});
